import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';

const NoDashboardData = () => {
  const { t } = useTranslation();
  return (
    <Grid container direction="row" justifyContent="center" alignItems="center">
      <Grid item padding={2}>
        {t('pages.dashboard.noData')}
      </Grid>
    </Grid>
  );
};

export default NoDashboardData;
